import React from "react";

const SkeletonLoading = ({ isBusiness = false }) => {
    const cardCount = isBusiness ? 6 : 3;

    return (
        <div className="tw:flex tw:flex-col tw:gap-4 tw:py-4">
            {[...Array(cardCount)].map((_, index) => (
                <div key={index} className="tw:bg-white tw:rounded-lg tw:border tw:border-gray-200 tw:p-6 tw:animate-pulse">
                    {/* Section Title */}
                    <div className="tw:h-6 tw:w-48 tw:bg-gray-200 tw:rounded tw:mb-6" />

                    <div className="tw:space-y-4">
                        {/* List items */}
                        {[1, 2, 3].map((item) => (
                            <div key={item} className="tw:flex tw:items-start tw:gap-4">
                                <div className="tw:h-4 tw:w-32 tw:bg-gray-100 tw:rounded" />
                                <div className="tw:h-4 tw:flex-1 tw:max-w-md tw:bg-gray-200 tw:rounded" />
                            </div>
                        ))}
                    </div>

                    {/* Bottom border simulation if needed */}
                    {index < cardCount - 1 && (
                        <div className="tw:mt-6 tw:h-px tw:bg-gray-100" />
                    )}
                </div>
            ))}
        </div>
    );
};

export default SkeletonLoading;
